import React, { useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Fade from '@material-ui/core/Fade';
import styled from 'styled-components';

const NotificationContext = React.createContext({
  showNotification: () => { },
});
export { NotificationContext };

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const NotificationOverlay = ({
  children
}) => {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('')
  const [severity, setSeverity] = useState('info');
  const [autoHide, setAutoHide] = useState(true);

  const showNotification = (message, type = 'info', autoH = true) => {
    setText(message);
    setSeverity(type);
    setOpen(true);
    setAutoHide(autoH);
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <NotificationContext.Provider
      value={{
        showNotification,
      }}
    >
      <div className="notification-overlay-children--wrapper">
        {children}
      </div>

      <Snackbar
        open={open}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={autoHide ? 10000 : null}
        transitionDuration={1000}
        TransitionComponent={Fade}
        onClose={handleClose}
        classes={{ root: `toastr-${severity}` }}
        message={text}
        style={{ zIndex: 11000 }}
      >
        <Alert onClose={handleClose} severity={severity}>
          {text.split('\n').map((line, index) => (
            <div key={index}>
              {line}
            </div>
          ))}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  )
}

export default NotificationOverlay;

const NotificationContainer = styled.div`
`;